<template>
  <div :class="types==1? 'swiper':'swiper1'">
    <swiper 
    :slidesPerView="1" 
    :autoplay="{ delay: 5000, disableOnInteraction: true }"
    :navigation="true" 
    :pagination="{ clickable: false  }"
    :scrollbar="{ draggable: false }" 
    :space-between="0" 
    :modules="modules" 
    @mouseenter="enter" 
    @mouseleave="leave" 
    @swiper="onSwiper" 
    @slideChange="onSlideChange">
      <swiper-slide v-for="(item, index) in params" :key="index" class="swiperItem">
            <img :src="item.img" alt="" />
            <div class="swiper_text ls1 wow animate__backInDown">
                <div class="swiper_text1 pb_008">{{ item.text }}</div>
                <div class="swiper_text1">{{ item.text1 }}</div>
            </div>
      </swiper-slide>
    </swiper>
    <img src="@/assets/computer/shouye/Right.png" alt="" @click="rightClick" class="rightpng wow animate__fadeInRight">
    <img src="@/assets/computer/shouye/Left.png" alt="" @click="leftClick" class="leftpng wow animate__fadeInLeft">
  </div>
</template>

<script setup >
 import { useRouter } from 'vue-router'
  const router = useRouter()

import { ref,defineProps, toRaw ,onMounted} from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
// interface B {
//   img: string;
// }
const props = defineProps({
  arrList:Array,
  type:Number,
}
);
 const types = ref()
const params = ref("") // 用于接收参数
 
onMounted(()=>{
    console.log("props",props); // 输出父组件传递过来的所有数据
    params.value = props.arrList; // 接收参数
    types.value = props.type
})

let modules = [Autoplay, Navigation, Pagination, Scrollbar, A11y];
//定义swiperNew,目的获取非响应式swiper
let swiperNew = null;
 
//鼠标移入
const enter = () => {
  swiperNew.autoplay.stop();
};
//鼠标移出
const leave = () => {
  swiperNew.autoplay.start();
};
const onSwiper = (swiper) => {
  // console.log(swiper);
 
  swiperNew = toRaw(swiper); //拿到swiper对象再转换为非响应式
};
const rightClick=()=>{
    swiperNew.slidePrev()
}
const leftClick=()=>{
    swiperNew.slideNext()

}
const onSlideChange = () => {
  // console.log("slide change");
};
</script>
<style  scoped>
.swiper {
  /* margin-top: 300px; */
  width: 100%;
  height: auto;
    position: relative;
}
  
img {
    width: 100%;
    height: 100%;
  }
 
.swiperItem {
   /* border: aqua solid 1px; */
   /* height: 200px; */
}
.swiperItem img{
  display: block;
   /* border: aqua solid 1px; */
   /* height: 200px; */
}
:deep( .swiper .swiper-pagination ) {
  display: none!important;
}
:deep( .swiper .swiper-button-prev ) {
  display: none!important;
}
:deep( .swiper .swiper-button-next){
    display: none!important;
}
:deep(.swiper-pagination) .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: rgb(229, 180, 127);
}
 
:deep(.swiper-pagination-bullet) {
  /* //修改分页器圆点大小 */
  width: 14px;
  height: 14px;
  background-color: #fff;
}
 
.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
:deep(.swiper-pagination-horizontal.swiper-pagination-bullets) .swiper-pagination-bullet {
  /* // 分页器远点之间的距离 */
  margin: 0 20px;
}
 
:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
  color: rgb(229, 180, 127);
}
.rightpng{
    position: absolute;
    top: 47%;
    right: 10%;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 2;
}
.leftpng{
    position: absolute;
    top: 47%;
    left: 10%;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 2;
}
.swiper_text{
    position: absolute;
    top: 42%;
    left: 32%;
    width: 35%;
    text-align: center;
}
.swiper_text1{
    width: 100%;
    color: #fff;
    font-size: 0.15rem;
    font-weight: 600;
}
</style>
